import { AskNiqPanel } from "@/components/askniq/AskNiqPanel";

export default function AskNiqFullPage() {
  return (
    <div className="space-y-4" data-testid="askniq-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Ask Niq</h1>
      <p className="text-xs text-[var(--oim-text-dim)]">Grounded Q&A over computed outputs only — every number binds to a source.</p>
      <AskNiqPanel fullPage />
    </div>
  );
}
